import * as d3 from "d3";
import {
    colonAnnotation,
    inrFormatter,
    numberFormat,
    colourScheme,
    responsivefy,
    make_x_gridlines, make_y_gridlines, generateDownloadData, contextMenu
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // Scales. Note the inverted domain fo y-scale: bigger is up!
    var x1Scale = d3.scaleLinear().range([0, chart.width]);
    var y1Scale = d3.scaleBand().rangeRound([chart.height, 0]).padding(0.002)
    var left1 = 4
    var x1AxisLabel = d3.axisBottom(x1Scale)
    var y1AxisLabel = d3.axisLeft(y1Scale)
    console.log("checkbox", checkbox, gridflag);


    // axios.post(url, filterParam).then(res => {
        let data = resData
        //  data.sort((a, b) => b.metric1 - a.metric1);
        console.log("dataa", data);


        // Data is nested by country
        var categories = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            .entries(data);
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width - chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        if (checkbox == true) {
            console.log("if condition")
            categories.forEach(function (d) {
                d.maxNumber = d3.max(d.values, function (d) {

                    return d.metric1;
                });
            });
            // Compute the minimum and maximum year and percent across symbols.
            y1Scale.domain(data.map(function (d) {
                return d.dim3_name;
            }));
            x1Scale.domain([0, d3.max(data.map((d) => {
                return d.metric1
            }))]);
            svg = d3.select(divId)
            svg.selectAll("*").remove();

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div3 = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')
            // Add an SVG element for each country, with the desired dimensions and margin.
            svg = d3.select(divId).selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", function (d, i) {
                    return categories[i] == categories[0] ? chart.width + chart.margin.left + chart.margin.right : chart.width + left1 + chart.margin.right
                })
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                //.call(responsivefy)
                .append("g")
                .attr("transform", function (d, i) {
                    return categories[i] == categories[0] ? "translate(" + chart.margin.left + "," + chart.margin.top + ")" : "translate(" + left1 + "," + chart.margin.top + ")"
                })
                .attr("id", (d) => {
                    return d.key
                })

            categories.forEach(function (d) {
                //CSS.escape(id) - will escape special character in id/key

                var svg = d3.select("#" + CSS.escape(d.key));
                var metric1ColorScale = d3.scaleSequential(colourScheme(d.values[0].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric2ColorScale = d3.scaleSequential(colourScheme(d.values[1].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric3ColorScale = d3.scaleSequential(colourScheme(d.values[2].dim4_name))
                    .domain([0, d.maxNumber]);
                var metric4ColorScale = d3.scaleSequential(colourScheme(d.values[3].dim4_name))
                    .domain([0, d.maxNumber]);
                svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", "translate(0," + chart.height + ")")
                    .call(x1AxisLabel.tickFormat(numberFormat).ticks(5))
                    .style('fill', '#E8E8E8')
                    .selectAll('text') //addidng text on x-axis
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.1em')
                    .attr('transform', 'rotate(-50)');

                //adding axis labels
                svg.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.height + chart.margin.top + 60) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => {
                        return d.key
                    });
                svg.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.margin.top - 40) + ")") // Adjust the y-coordinate here
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => {
                        return d.key;
                    });
                //adding axis labels
                svg.append("g")
                    .attr("class", "y axis")
                    .call(y1AxisLabel)
                    .attr("transform", "translate(0,0)")
                    .call(d3.axisLeft(y1Scale))
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', "-0.4em")
                    .attr("dy", "-0.2em")
                    .text(function (d) {
                        return d;
                    })
                svg.selectAll('.y.axis .tick line')
                    .attr('transform', `translate(0, ${-y1Scale.bandwidth() / 4.2})`)

                svg.append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 0 - chart.margin.left)
                    .attr('x', 0 - (chart.height / 2) + 50)
                    .attr("dy", ".71em")
                    .style("text-anchor", "end")
                    .style('fill', fontColor)
                    .style('font-size', fontSize)
                    .text(chart.y1AxisDisplayName)

                console.log("gridflag", gridflag)

                /*if (gridflag === true) {
                    addGridlines(svg, x1Scale, y1Scale, chart);
                }*/

                if (gridflag === true) {
                    // add the X gridlines
                    svg.append("g")
                        .attr("class", "grid")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(make_x_gridlines(x1Scale)
                            .tickSize(-chart.height)
                            .tickFormat(""))
                        .style("stroke-width", 0.1)

                    // add the y gridlines
                    svg.append("g")
                        .attr("class", "grid")
                        //.attr("transform", "translate(0," + chart.margin-20 + ")")
                        .call(make_y_gridlines(y1Scale)
                            .tickSize(-chart.width)
                            .tickFormat(""))
                        .style("stroke-width", 0.1);
                }

                // Accessing nested data: https://groups.google.com/forum/#!topic/d3-js/kummm9mS4EA
                // data(function(d) {return d.values;})
                // this will dereference the values for nested data for each group
                svg.selectAll(".barmpc")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("rect")
                    .attr("class", "barmpc")
                    .attr("d", function (d) {
                        return console.log("keyss", d.key)
                    })
                    .attr("x", '0.1em')
                    .attr("y", function (d) {
                        return y1Scale(d.dim3_name);
                    })
                    .attr("width", function (d) {
                        return x1Scale(d.metric1);
                    })
                    .attr("d", function (d) {
                        return console.log("va", d.values)
                    })
                    .attr("height", y1Scale.bandwidth() / 1.7)
                    .attr("fill", function (d) {
                        if (
                            d.dim2_name == chart.x1MetricTooltip
                        ) {
                            console.log("color", d.dim4_name);
                            return metric3ColorScale(d.metric1);
                        } else if (d.dim2_name == chart.y1MetricTooltip) {
                            return metric1ColorScale(d.metric1);
                        } else if (d.dim2_name == chart.x2MetricTooltip) {
                            return metric4ColorScale(d.metric1);
                        } else {
                            return metric2ColorScale(d.metric1);
                        }
                    })

                    .on("mousemove", function (d) {
                        console.log(d3.event, d)
                        div3.transition()
                            .duration(200)
                            .style("opacity", .9);
                        div3.html(
                            chart.y1AxisDisplayName + colonAnnotation + d.dim3_name + "<br/>"
                            + d.dim2_name + colonAnnotation + inrFormatter(d.metric1))
                            .style("left", d3.event.clientX - divId.getBoundingClientRect().left + "px")
                            .style("top", d3.event.clientY - divId.getBoundingClientRect().top + "px");
                    })
                    .on("mouseout", function () {
                        div3.transition().style("opacity", 0)
                    })
                    .on('contextmenu', function(d) {
                        // Prepare clickedData with both axes' info
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName]: [d.dim3_name],               // e.g., "metric1"
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim2_name]
                        };
                        console.log("clickedData",clickedData);
                        // Generate the menu with current config and filters
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                        // Show the context menu
                        contextMenu(menuItems).call(this, clickedData);

                        // Prevent default context menu
                        d3.event.preventDefault();
                    });
                svg.selectAll(".barmpc-text")
                    .data(function (d) {
                        return d.values;
                    })
                    .enter()
                    .append("text")
                    .attr("class", "barmpc-text")
                    .text(function (d) {
                        // Add the text content here
                        return numberFormat(d.metric1); // Adjust this based on your data
                    })
                    .attr("x", function (d) {
                        return x1Scale(d.metric1) / 2.5; // Center the text within the rectangle
                    })
                    .attr("y", function (d) {
                        return y1Scale(d.dim3_name) + y1Scale.bandwidth() / 2.5; // Center the text vertically within the rectangle
                    })
                    .style("font-size", "15px") // Set the font size as needed
                    .style("font-weight", "bold")
                    .style("fill", "black"); // Set the text color as needed
            });
        } else {
            // Clear old chart
            d3.select(divId).selectAll("*").remove();
            d3.select("tooltip" + divId.id).remove();

            // Create layout containers
            const wrapper = d3.select(divId)
                .append("div")
                .attr("class", "chart-wrapper")
                .style("display", "flex")
                .style("align-items", "flex-start")
                .style("overflow", "hidden");

            const yAxisContainer = wrapper.append("div")
                .attr("class", "y-axis-container")
                .style("flex", "0 0 auto")
                .style("background", "#fff");

            const chartsScroll = wrapper.append("div")
                .attr("class", "charts-scroll")
                .style("overflow-x", "auto")
                .style("white-space", "nowrap");

            // Tooltip
            const div = d3.select(divId).append('div')
                .attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;');

            // Y scale (shared across all charts)
            const y1Scale = d3.scaleBand()
                .domain(data.map(d => d.dim3_name))
                .range([0, chart.height])
                .padding(0.1);

            const y1Axis = d3.axisLeft(y1Scale);

            // ✅ Draw Y-axis ONCE
            const ySvg = yAxisContainer.append("svg")
                .attr("width", chart.margin.left + 40)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom);

            ySvg.append("g")
                .attr("transform", `translate(${chart.margin.left},${chart.margin.top})`)
                .call(y1Axis)
                .selectAll("text")
                .style("font-size", axisLabelFontSize)
                .style("text-anchor", "end")
                .attr('dx', "-0.4em")
                .attr("dy", y1Scale.bandwidth() /6 + "px"); // center ticks

            ySvg.selectAll('.y.axis .tick line')
                 .attr('transform', `translate(0, ${y1Scale.bandwidth() / 1.1})`);

            ySvg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 10)   // push left a bit
                .attr('x', 0 - (chart.height / 2))       // center vertically
                .attr("dy", ".71em")
                .style("text-anchor", "middle")
                .style('fill', fontColor)
                .style('font-size', fontSize)
                .text(chart.y1AxisDisplayName);

            // Compute max per category
            categories.forEach(cat => {
                cat.maxNumber = d3.max(cat.values, d => d.metric1);
            });

            // ✅ Draw charts in scrollable container
            const svg = chartsScroll.selectAll("svg")
                .data(categories)
                .enter()
                .append("svg")
                .attr("width", chart.width+chart.margin.right)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .style("display", "inline-block")
                .append("g")
                .attr("transform", `translate(${chart.margin.right},${chart.margin.top})`);

            // Render chart per category
            svg.each(function (category) {
                console.log("category inside svg",category);
                const localSvg = d3.select(this);

                const minValue = d3.min(category.values, d => d.metric1);
                const maxValue = d3.max(category.values, d => d.metric1);

                const x1Scale = d3.scaleLinear()
                    .domain([
                        minValue < 0 ? minValue : 0, // if negatives exist, use min; else start from 0
                        maxValue
                    ])
                    .range([0, chart.width]);

                const x1AxisLabel = d3.axisBottom(x1Scale);

                // Color scales
                const metric1ColorScale = d3.scaleSequential(colourScheme(category.values[0].dim4_name))
                    .domain([0, category.maxNumber]);
                const metric2ColorScale = d3.scaleSequential(colourScheme(category.values[1]?.dim4_name ?? category.values[0]?.dim4_name))
                    .domain([0, category.maxNumber]);
                const metric3ColorScale = d3.scaleSequential(colourScheme(category.values[2]?.dim4_name ?? category.values[0]?.dim4_name))
                    .domain([0, category.maxNumber]);
                const metric4ColorScale = d3.scaleSequential(colourScheme(category.values[3]?.dim4_name ?? category.values[0]?.dim4_name))
                    .domain([0, category.maxNumber]);

                // X Axis
                localSvg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", `translate(0,${chart.height})`)
                    .call(x1AxisLabel.tickFormat(numberFormat).ticks(5))
                    .selectAll('text')
                    .style('font-size', axisLabelFontSize)
                    .style('text-anchor', 'end')
                    .attr('dx', '-.1em')
                    .attr('transform', 'rotate(-50)');

                // Y Axis
                // localSvg.append("g")
                //     .attr("class", "y axis")
                //     .call(y1AxisLabel)
                //     .selectAll('text')
                //     .style('font-size', axisLabelFontSize)
                //     .style('text-anchor', 'end')
                //     .attr('dx', "-0.4em")
                //     .attr("dy", y1Scale.bandwidth() / 2 + "px");

                localSvg.append("text")
                    .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 60) + ")")
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => { return d.key });

                localSvg.append("text")
                    .attr("transform",
                        "translate(" + (chart.width / 2) + " ," +
                        (chart.margin.top - 40) + ")") // Adjust the y-coordinate here
                    .style("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill", fontColor)
                    .text((d) => {
                        return d.key;
                    });

                // Y axis label
                // localSvg.append('text')
                //     .attr('transform', 'rotate(-90)')
                //     .attr('y', 0 - chart.margin.left)
                //     .attr('x', 0 - (chart.height / 2) + 50)
                //     .attr("dy", ".71em")
                //     .style("text-anchor", "end")
                //     .style('fill', fontColor)
                //     .style('font-size', fontSize)
                //     .text(chart.y1AxisDisplayName);

                // localSvg.selectAll('.y.axis .tick line')
                //     .attr('transform', `translate(0, ${y1Scale.bandwidth() / 1.1})`);

                // Gridlines
                if (gridflag) {
                    localSvg.append("g")
                        .attr("class", "grid")
                        .attr("transform", `translate(0,${chart.height})`)
                        .call(d3.axisBottom(x1Scale).tickSize(-chart.height).tickFormat(""));

                    localSvg.append("g")
                        .attr("class", "grid")
                        .call(d3.axisLeft(y1Scale).tickSize(-chart.width).tickFormat(""));
                }

                // Bars
                localSvg.selectAll(".barmpc")
                    .data(category.values)
                    .enter()
                    .append("rect")
                    .attr("class", "barmpc")
                    .attr("x", '0.1em')
                    .attr("y", function (d) { return y1Scale(d.dim3_name); })
                    .attr("width", d => x1Scale(d.metric1))
                    .attr("height", y1Scale.bandwidth() / 1.7)
                    .attr("fill", d => {
                        if (d.dim2_name === chart.x1MetricTooltip) return metric3ColorScale(d.metric1);
                        else if (d.dim2_name === chart.y1MetricTooltip) return metric1ColorScale(d.metric1);
                        else if (d.dim2_name === chart.x2MetricTooltip) return metric4ColorScale(d.metric1);
                        return metric2ColorScale(d.metric1);
                    })
                    .on("mousemove", function (d) {
                        div.transition().duration(200).style("opacity", .9);
                        div.html(
                            `${chart.y1AxisDisplayName}${colonAnnotation}${d.dim3_name}<br/>${d.dim2_name}${colonAnnotation}${inrFormatter(d.metric1)}`
                        )
                            .style("left", (d3.event.clientX - divId.getBoundingClientRect().left) + "px")
                            .style("top", (d3.event.clientY - divId.getBoundingClientRect().top) + "px");
                    })
                    .on("mouseout", function () {
                        div.transition().style("opacity", 0);
                    })
                    .on('contextmenu', function (d) {
                        const clickedData = {
                            [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName]: [d.dim3_name],
                            [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim2_name]
                        };
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
                        contextMenu(menuItems).call(this, clickedData);
                        d3.event.preventDefault();
                    });

                // Bar labels
                localSvg.selectAll(".barmpc-text")
                    .data(category.values)
                    .enter()
                    .append("text")
                    .attr("class", "barmpc-text")
                    .text(d => numberFormat(d.metric1))
                    .attr("x", d => x1Scale(d.metric1) / 2.5)
                    .attr("y", d => y1Scale(d.dim3_name) + y1Scale.bandwidth() / 2.4)
                    .style("font-size", "15px")
                    .style("font-weight", "bold")
                    .style("fill", d => d.metric1 > category.maxNumber/2 ? "white" : "black");
            });
        }

    // })
}

